import React from 'react';
import MessageItem from './messageItem';
import moment from 'moment';

const MessageGroup = React.memo(({ dateLabel, messages, typing, messageType }) => (
  <>
    {messages.map((msg, idx) => (
      <MessageItem
        key={`${msg?.props?.message?.timeStamp || moment(msg?.timestamp).utc().toISOString()}-${dateLabel}-${idx}`}
        message={msg}
        showLoader={typing && idx === 0}
        messageType={messageType}
      />
    ))}
    <div className="rcw-title-timestamp-container">
      <div className="rcw-title-timestamp">{dateLabel}</div>
    </div>
  </>
));

export default MessageGroup;
